// extracted by mini-css-extract-plugin
module.exports = {"flex_direction":"People_flex_direction__3TIr0","input":"People_input__3CoOR"};